import { combineReducers } from 'redux';

import { AllActions } from '../actions/allActions';
import { InternalActionTypes } from '../constants/actionTypes';
import { ById } from '../store/normalizedState';
import { NormalizedClient } from '../models/normalized/normalizedClient';

import * as ReducerHelper from './reducerHelper';

function allIdsReducer(state: string[] = [], action: AllActions): string[] {
  switch (action.type) {
    case InternalActionTypes.ArchivedClientsLoaded:
      return ReducerHelper.addAllIds(state, action.result.entities.clients);
    case InternalActionTypes.ClientArchived:
      return ReducerHelper.addAllIds(state, action.result.entities.clients);
    case InternalActionTypes.ClientUnarchived:
      return ReducerHelper.removeId(state, action.result.result);
    default:
      return state;
  }
}

function byIdReducer(state: ById<NormalizedClient> = {}, action: AllActions): ById<NormalizedClient> {
  switch (action.type) {
    case InternalActionTypes.ArchivedClientsLoaded:
      return ReducerHelper.updateAll(state, action.result.entities.clients);
    case InternalActionTypes.ClientArchived:
      return ReducerHelper.updateAll(state, action.result.entities.clients);
    case InternalActionTypes.ClientUnarchived:
      return ReducerHelper.removeItem(state, action.result.result);
    default:
      return state;
  }
}

export const archivedClientsReducer = combineReducers({
  allIds: allIdsReducer,
  byId: byIdReducer,
});
